import React from "react";

const ContactDetailsSection = ({
  applicant,
  showContactDetails,
  setShowContactDetails,
  handleContactEditClick,
  formatPhoneNumber,
  account,
}) => {
  console.log("ContactDetailsSection", account);
  return (
    <div className="mb-4">
      <div
        className="d-flex align-items-center mb-3"
        style={{ cursor: "pointer" }}
        onClick={() => setShowContactDetails(!showContactDetails)}
      >
        <span
          style={{
            color: "#e91e63",
            fontSize: "14px",
            fontWeight: "600",
            marginRight: "8px",
          }}
        >
          Contact
        </span>
        <i
          className={`fas fa-chevron-${showContactDetails ? "down" : "right"}`}
          style={{ color: "#e91e63", fontSize: "12px" }}
        ></i>
      </div>

      {showContactDetails && (
        <div className="[ details-section ] [ mb-3 ]">
          <div className="[ row ] [ details-section__header">
            <div className="[ col-12 ]">
              <h3 className="[ d-flex justify-content-between align-items-center ]">
                CONTACT DETAILS
                <button
                  type="button"
                  className="[ btn edit-btn ]"
                  aria-label="edit"
                  onClick={handleContactEditClick}
                >
                  <span className="[ edit-icon ]"></span>
                  <span className="[ edit-btn__label ]">Edit</span>
                </button>
              </h3>
            </div>
          </div>
          <div className="[ row ] [ details-section__item ]">
            <div className="[ col-5 ] [ details-section__item-label ]">
              Email:
            </div>
            <div
              className="[ col-7 ] [ details-section__item-description ]"
              style={{ textTransform: "none" }}
            >
              {applicant?.member?.email || account.email || "—"}
            </div>
          </div>
          <div className="[ row ] [ details-section__item ]">
            <div className="[ col-5 ] [ details-section__item-label ]">
              Mobile no.:
            </div>
            <div className="[ col-7 ] [ details-section__item-description ]">
              {applicant?.address?.currentAddressCellPhoneArea
                ? formatPhoneNumber(
                    applicant?.address?.currentAddressCellPhoneArea +
                      applicant?.address?.currentAddressCellPhone
                  )
                : formatPhoneNumber(account.msisdn)}
            </div>
          </div>
          <div className="[ row ] [ details-section__item ]">
            <div className="[ col-5  [ details-section__item-label ]">
              Home no.:
            </div>
            <div className="[ col-7 ] [ details-section__item-description ]">
              {formatPhoneNumber(
                applicant?.address?.currentAddressPhoneArea +
                  applicant?.address?.currentAddressPhone
              )}
            </div>
          </div>
          <div className="[ row ] [ details-section__item ]">
            <div className="[ col-5 ] [ details-section__item-label ]">
              Other no.:
            </div>
            <div className="[ col-7 ] [ details-section__item-description ]">
              {formatPhoneNumber(
                applicant?.contact?.alternateContactArea +
                  applicant?.contact?.alternateContactPhone
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactDetailsSection;
